import { BaseProxy } from "@/proxies/BaseProxy";

export class EventsProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `events`,
      parameters,
    });
  }
}
